<template>
  <main class="main m_device_search_list" role="main" v-show="show">
    <div class="main_con">
      <div class="list_con_top" :class="{ tab_fix: isTabFixed }">
        <div class="search_wrap">
          <div class="search_input">
            <div class="s_input">
              <input
                maxlength="30"
                @input="searchChangeFunc($event)"
                ref="searchInput"
                @click="searchInputSel"
                v-model="searchText"
              />
            </div>
            <!-- <div class="s_del" @click="searchTextDel" v-if="isCloseBtn">
              <img
                :src="require(`@/assets/front/images/new/i_x_input.svg`)"
                alt=""
              />
            </div> -->
            <div class="s_search">
              <img
                :src="require(`@/assets/front/images/new/i_search_n.svg`)"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="s_tag_wrap">
          <div class="s_tag">
            <ul v-if="mobileCategorySub">
              <li
                v-for="(item, index) in mobileCategorySub"
                :key="index"
                @click="categorySubSel(item.categoryId)"
              >
                <p :class="{ on: categorySub == item.categoryId }">
                  #{{ item.categoryName }}
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div class="category_wrap">
          <div class="category">
            <ul v-if="mobileCategoryMain">
              <li @click="categoryMainSel(0)">
                <p :class="{ on: categoryMain == 0 }">전체</p>
              </li>
              <li
                v-for="(item, index) in mobileCategoryMain"
                :key="index"
                @click="categoryMainSel(item.categoryId)"
              >
                <p :class="{ on: categoryMain == item.categoryId }">
                  {{ item.categoryName }}
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="list_con_wrap" ref="list_con_wrap">
        <div ref="dummy"></div>
        <div class="list_con" :class="{ top_fixed: isTabFixed }">
          <div class="list_sort_wrap" @click="deviceSortOpen">
            <div class="list_sort">{{ deviceSortTxt }}</div>
            <div class="list_sort_img">
              <img
                :src="
                  require(`@/assets/front/images/mobile/i_ar_list_order.png`)
                "
                alt=""
              />
            </div>
          </div>
          <div v-if="this.mobileDevice.content">
            <div
              v-for="(item, index) in this.mobileDevice.content"
              :key="index"
            >
              <div
                class="list_device"
                :class="{ on: deviceId == item.deviceId }"
                @click="
                  deviceInfo(item.deviceId, item.deviceName, item.modelName)
                "
              >
                <div class="d_img">
                  <img :src="item.deviceImage" alt="" />
                </div>
                <div class="d_info">
                  <div class="d_txt_1">{{ item.modelName }}</div>
                  <div class="d_txt_2">{{ item.deviceName }}</div>
                  <div class="d_txt_3">
                    <ul>
                      <li
                        v-for="(color, index_color) in item.colors"
                        :key="index_color"
                      >
                        <div
                          :style="`background-color:#${color.colorCode}`"
                        ></div>
                      </li>
                    </ul>
                  </div>
                  <div class="d_txt_4">
                    <span>공시지원</span>{{ toCurrency(item.supportMoney) }}원
                  </div>
                  <div class="d_txt_4">
                    <span>출고가</span>{{ toCurrency(item.factoryPrice) }}원
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="list_empty">
            <div class="empty_img">
              <img src="@/assets/front/images/mobile/i_empty_n.svg" alt="" />
            </div>
            <div class="empty_txt">검색 결과가 없습니다.</div>
          </div>
        </div>
      </div>
    </div>
    <DeviceDetailModal
      ref="deviceDetailModal"
      @close="closeDeviceDetailModal"
      @select="selectInfo"
      :deviceDetail="mobileDeviceDetail.content"
    ></DeviceDetailModal>
    <DeviceSortModal
      :show="isDeviceSortOpen"
      @close="deviceSortModalClose"
      ref="deviceSortModal"
    />
  </main>
</template>

<script>
import DeviceSortModal from '@/common/components/mobile/modal/DeviceSortModal';
import DeviceDetailModal from '@/common/components/mobile/DeviceDetail.vue';
import * as util from '@common/lib/common/utils.js';
import DesignPopup2 from '@/common/components/modal/DesignPopup2';
import {
  mapActions as shopMapActions,
  mapGetters as shopMapGetters,
} from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';
import * as shopGetters from '@common/store/modules/shop/getters';
import { default as format } from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import { sleep, nativeDeviceInfo } from '@common/lib/common/utils';

import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

export default {
  name: 'device',
  props: {
    show: Boolean,
    mobileCategoryMain: Array,
    mobileCategorySub: Array,
    telecomId: String,
  },
  components: {
    DeviceSortModal,
    DeviceDetailModal,
  },
  data() {
    return {
      isTabFixed: false,
      deviceSortTxt: '퍼스 추천 순',
      deviceSortVal: 'RECOMMAND',
      isDeviceSortOpen: false,
      isCompleted: false,
      searchText: '',
      fetchCompleted: false,
      categoryMain: 0,
      categorySub: 0,
      deviceId: 0,
      deviceName: '',
      modelName: '',
    };
  },
  async created() {
    // await this.searchDevice();
    this.isCompleted = true;
  },
  async mounted() {},
  computed: {
    ...mobileMapGetters({
      mobileDevice: mobileTypes.MOBILE_DEVICE,
      mobileDeviceDetail: mobileTypes.MOBILE_DEVICE_DETAIL,
    }),
    isCloseBtn() {
      if (this.searchText == '') {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    ...mobileMapActions([
      mobileTypes.SELECT_MOBILE_DEVICE,
      mobileTypes.SELECT_MOBILE_DEVICE_DETAIL,
    ]),
    toCurrency(val) {
      return util.toCurrency(val);
    },
    selectInfo(selColor, noColor, deviceImage, factoryPrice) {
      // alert(1);
      this.$refs.deviceDetailModal.isOpen = false;
      this.$emit(
        'deviceSel',
        selColor,
        noColor,
        this.deviceId,
        this.deviceName,
        this.modelName,
        deviceImage,
        factoryPrice,
      );
    },
    async deviceInfo(deviceId, deviceName, modelName) {
      this.deviceId = deviceId;
      this.deviceName = deviceName;
      this.modelName = modelName;

      let params = {
        id: deviceId,
      };
      await this[mobileTypes.SELECT_MOBILE_DEVICE_DETAIL](params);

      console.log('mobileDeviceDetail');

      console.log(this.mobileDeviceDetail);

      // this.$refs.deviceDetailModal.deviceDetail = this.mobileDeviceDetail.content;

      this.$refs.deviceDetailModal.selectColorIndex = 0;

      this.$refs.deviceDetailModal.selectColorCode = this.mobileDeviceDetail.content.colors[0].colorCode;

      this.$refs.deviceDetailModal.selectColorName = this.mobileDeviceDetail.content.colors[0].colorName;

      this.$refs.deviceDetailModal.selectColorImage = this.mobileDeviceDetail.content.colors[0].colorImage;

      this.$refs.deviceDetailModal.isOpen = true;
    },
    closeDeviceDetailModal() {
      this.$refs.deviceDetailModal.isOpen = false;
    },
    searchTextDel() {
      // alert(this.searchText);
      this.searchText = '';
      this.$refs.searchInput.focus();
      // alert(this.searchText);
      // this.isValue = false;
      this.fetchCompleted = false;
    },
    async searchTextSend() {
      this.fetchCompleted = false;
      await sleep(100);
      if (this.searchText.trim() == '') {
        this.searchText = '';
        // this.isValue = true;
        this.fetchCompleted = false;
        return false;
      } else if (this.searchText.trim().length < 2) {
        // this.isValue = true;
        this.fetchCompleted = false;
        return false;
      }

      this.searchText = this.searchText.trim();
      // alert(this.searchText);
      // await this.getListPageOne();
      // this.isValue = false;
    },
    async deviceSortModalClose(checked) {
      if (checked) {
        this.deviceSortTxt = this.$refs.deviceSortModal.selectSortTxt;
        this.deviceSortVal = this.$refs.deviceSortModal.selectSortVal;

        await this.searchDevice();
      }

      this.isDeviceSortOpen = false;
    },
    deviceSortOpen() {
      this.isDeviceSortOpen = true;
    },
    async searchDevice() {
      let params = {
        callPart: 'CUSTOMER',
        telecomId: this.telecomId,
        categoryId: this.categoryMain,
        categoryIdSub: this.categorySub,
        keyword: this.searchText,
        orderType: this.deviceSortVal,
      };

      console.log('params');
      console.log(params);
      await this[mobileTypes.SELECT_MOBILE_DEVICE](params);

      console.log('mobileDevice');
      console.log(this.mobileDevice);
    },
    async categoryMainSel(categoryId) {
      // this.$refs.dummy.scrollIntoView({ behavior: 'auto' });
      this.categoryMain = categoryId;

      await this.searchDevice();

      this.$emit('categorySel');
    },
    async categorySubSel(categoryId) {
      // this.$refs.dummy.scrollIntoView({ behavior: 'auto' });
      if (categoryId == this.categorySub) {
        this.categorySub = 0;
      } else {
        this.categorySub = categoryId;
      }
      await this.searchDevice();
      this.$emit('categorySel');
    },
    searchInputSel() {
      this.$emit('categorySel');
    },
    async searchChangeFunc(event) {
      console.log(event.target.value);
      this.searchText = event.target.value;
      await this.searchDevice();
      this.$emit('categorySel');
    },
  },
};
</script>
